import { render, staticRenderFns } from "./AbkEventDescriptionForm.vue?vue&type=template&id=19f4cb6e&scoped=true&"
import script from "./AbkEventDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./AbkEventDescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkEventDescriptionForm.vue?vue&type=style&index=0&id=19f4cb6e&lang=scss&scoped=true&"
import style1 from "./AbkEventDescriptionForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f4cb6e",
  null
  
)

export default component.exports